import { Flex, Grid, Skeleton } from "@chakra-ui/react";
import { useGetCurrentTuneUp } from "hooks";
import { IconWrenchGg } from "icons";
import { TuneUpLevelBar } from "./TuneUpLevelBar";

const TuneUpSkeleton = () => (
  <Skeleton
    height="18px"
    startColor="whiteAlpha.100"
    endColor="whiteAlpha.300"
    borderRadius="md"
  />
);

// Helper function to format camelCase to Title Case with spaces
const formatTunableField = (field: string): string => {
  // Split camelCase into separate words and capitalize first letter of each word
  return field
    // Insert a space before all capital letters and remove potential leading space
    .replace(/([A-Z])/g, ' $1')
    .trim()
    // Capitalize first letter of the string
    .replace(/^./, str => str.toUpperCase());
};

const TuneUpStats = () => {
  const { data: currentTuneUp, isLoading } = useGetCurrentTuneUp();
  
  if (isLoading || !currentTuneUp?.getCurrentTuneUp) {
    return (
      <Grid
        templateColumns="repeat(3, 1fr)"
        gap={4}
        w="full"
        position="absolute"
        bottom="2"
        left="0"
        px="1rem"
      >
        {[...Array(3)].map((_, index) => (
          <TuneUpSkeleton key={index} />
        ))}
      </Grid>
    );
  }

  const { 
    upgrade1TunableMetric, 
    upgrade1Value,
    upgrade2TunableMetric, 
    upgrade2Value,
    upgrade3TunableMetric,
    upgrade3Value
  } = currentTuneUp.getCurrentTuneUp;
  
  return (
    <Flex
      flexDir="row"
      gap={4}
      w="full"
      position="absolute"
      bottom="2"
      left="0"
      px="1rem"
    >
      {upgrade1TunableMetric && (
        <TuneUpLevelBar
          maxValue={6}
          currentValue={0}
          title={formatTunableField(upgrade1TunableMetric || '')}
          icon={<IconWrenchGg w={{ base: '1rem', md: '1.25rem' }} h={{ base: '1rem', md: '1.25rem' }} />}
          tunedUpIcon={<IconWrenchGg w={{ base: '1rem', md: '1.25rem' }} h={{ base: '1rem', md: '1.25rem' }} />}
          isTunedUp={true}
          tuneUpDirection={upgrade1Value && upgrade1Value > 0 ? 'up' : 'down'}
        />
      )}
      
      {upgrade2TunableMetric && (
        <TuneUpLevelBar
          maxValue={6}
          currentValue={0}
          title={formatTunableField(upgrade2TunableMetric || '')}
          icon={<IconWrenchGg w={{ base: '1rem', md: '1.25rem' }} h={{ base: '1rem', md: '1.25rem' }} />}
          tunedUpIcon={<IconWrenchGg w={{ base: '1rem', md: '1.25rem' }} h={{ base: '1rem', md: '1.25rem' }} />}
          isTunedUp={true}
          tuneUpDirection={upgrade2Value && upgrade2Value > 0 ? 'up' : 'down'}
        />
      )}
      
      {upgrade3TunableMetric && (
        <TuneUpLevelBar
          maxValue={6}
          currentValue={0}
          title={formatTunableField(upgrade3TunableMetric || '')}
          icon={<IconWrenchGg w={{ base: '1rem', md: '1.25rem' }} h={{ base: '1rem', md: '1.25rem' }} />}
          tunedUpIcon={<IconWrenchGg w={{ base: '1rem', md: '1.25rem' }} h={{ base: '1rem', md: '1.25rem' }} />}
          isTunedUp={true}
          tuneUpDirection={upgrade3Value && upgrade3Value > 0 ? 'up' : 'down'}
        />
      )}
    </Flex>
  );
};

export default TuneUpStats;